module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00678.80942c56.jpg";